<template>
  <div id="chart">
    <apexchart :type="type" :options="chartOptions" :series="series" :labels="labels" :width="width"></apexchart>
  </div>
</template>

<script>
  export default {
    name: 'PieChart',
    props: ['type', 'series', 'labels', 'width', 'chartOptions'],
  }
</script>
